import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="flex flex-col lg:flex-row min-h-[500px] md:min-h-[600px]">
      <div className="flex-1 relative bg-background-100 overflow-hidden flex items-center justify-center p-12 md:p-16">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20elegant%20minimalist%20composition%20with%20warm%20cream%20and%20soft%20golden%20amber%20flowing%20organic%20shapes%2C%20delicate%20layered%20textures%20creating%20depth%2C%20sophisticated%20modern%20art%20style%2C%20gentle%20gradients%20from%20cream%20to%20amber%2C%20airy%20and%20light%20atmosphere%2C%20editorial%20quality%2C%20no%20text&width=900&height=700&seq=cta-left-image&orientation=landscape"
          alt="AI学习之旅"
          className="absolute inset-0 w-full h-full object-cover object-top opacity-90"
        />
        <div className="absolute inset-0 bg-background-100/30"></div>
        <div className="relative z-10">
          <span className="inline-block text-xs text-foreground-500 tracking-widest uppercase mb-4">开启你的</span>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl text-foreground-950 leading-tight">
            AI学习<br />之旅
          </h2>
        </div>
      </div>

      <div className="flex-1 bg-background-50 flex items-center justify-center p-8 md:p-16">
        <div className="max-w-md text-center">
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-4">
            准备好<br />改变未来了吗？
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
            加入超过5000名学员，在bbgpt.online开启你的AI学习之旅。
            无论你是零基础入门还是进阶提升，这里都有适合你的课程。
          </p>
          <Link
            to="/courses"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-foreground-900 text-background-50 font-medium rounded-full hover:bg-foreground-800 transition-all duration-300 cursor-pointer whitespace-nowrap text-sm"
          >
            立即开始学习
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}